import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect, useParams, useLocation } from 'react-router-dom';
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Partners } from "./components/partners";
import { About } from "./components/about";
import { useTranslation } from 'react-i18next';
import { Media } from "./components/media";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json"; 
import SmoothScroll from "smooth-scroll";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1500,
  speedAsDuration: true,
});

const LandingPage = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      localStorage.setItem('lng', lang);
    }
  }, [lang, i18n]);

  useEffect(() => {
      if (location.hash) {
        setTimeout(() => {
          const element = document.querySelector(location.hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100); 
      }
  }, [location]);

  return (
    <>
      <Navigation />
      <Header />
      <About />
      <Partners data={landingPageData.Partners} />
      <Media data={landingPageData.Gallery} />
      <Contact />
    </>
  );
};

const App = () => {
  const currentUrl = window.location.href;
  const splitUrl = currentUrl?.split("/");
  const urlLng = splitUrl[3] && splitUrl[3]?.split("#");
  const lng = localStorage.getItem('lng') || urlLng || 'hy';
  
  return (
    <Router>
    <Switch>
        {/* Route for language-specific pages and redirection for paths with additional segments */}
        <Route path="/:lang(en|hy)/:extra?" render={({ match }) => {
          const { extra } = match.params;
          if (extra) {
            return <Redirect to={`/${lng}`} />;
          } else {
            return <LandingPage />;
          }
        }} />
        
        {/* Redirect exact root to default language */}
        <Redirect exact from="/" to={`/${lng}`} />
        
        {/* Catch-all route for any undefined paths */}
        <Route render={() => <Redirect to={`/${lng}`} />} />
      </Switch>
    </Router>
  );
};

export default App;